import { Link } from 'react-router-dom';
import { LayersIcon, PlusIcon } from 'lucide-react';
import { ProductImage } from '../../ui/ProductImage';
import { PageHeader } from '../ui/PageHeader';
import { OfferTabs } from './OfferTabs';
import { EmptyState } from '../ui/EmptyState';
import { plural } from '../../core/format/text';
import { useAdmin } from '../AdminContext';
import { tierIn } from '../../data/gifts';
import { errorCount, routineChecks } from './catalogRules';
import { btnPrimary } from '../ui/styles';
import { euro } from '../../core/format/currency';
import { monthsLabel } from '../../utils/catalog';
import { useCan } from '../useCan';
import { useCosts } from '../margin/useCosts';
import { MarginBadge } from '../margin/MarginBadge';
import { basketMarginPercent, marginLines } from '../../core/rules/margin';
import { vatRateOf } from '../../core/rules/revenue';

/** Alle protocollen. De prijs is altijd de som van de producten. */
export function Routines() {
  const {
    catalog,
    index,
    site
  } = useAdmin();
  const {
    canAll
  } = useCan();
  const showMargin = canAll('finance.margin');
  const {
    data: costs
  } = useCosts(showMargin);
  return <div data-id="element-932" data-mp="737r6201lujs">
      <PageHeader title="Protocollen" description="Complete routines die je als geheel aanbiedt. De prijs is altijd de som van de producten — die hoef je dus nooit zelf bij te houden." actions={<Link to="/be/protocollen/nieuw" className={btnPrimary} data-id="element-934" data-mp="fyniocdbrxm7">
            <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-935" data-mp="3fdisu29qwphi" />
            Nieuw protocol
          </Link>} data-id="element-933" data-mp="72xyu7rizbax" />
      <OfferTabs data-id="element-936" data-mp="3ocmd39knfaxl" />

      {catalog.routines.length === 0 ? <EmptyState icon={LayersIcon} title="Nog geen protocollen" text="Stel een protocol samen uit je producten; de prijs rekent zichzelf uit." action={<Link to="/be/protocollen/nieuw" className={btnPrimary} data-id="element-938" data-mp="13lvlmnna6ul2">
              Nieuw protocol
            </Link>} data-id="element-937" data-mp="3ob2xll6th3wv" /> : <ul className="grid gap-4 md:grid-cols-2" data-id="element-939" data-mp="34oczimxcofx5">
        {catalog.routines.map(r => {
        const totals = index.routineTotals(r);
        const gift = tierIn(site.giftTiers, totals.price);
        const errors = errorCount(routineChecks(r));
        const treatment = index.treatmentForRoutine(r);
        return <li key={r.id} data-id="element-940" data-mp="39or8q8aotvwr">
              <Link to={`/be/protocollen/${r.id}`} className="flex h-full flex-col rounded-lg border border-line bg-white p-5 transition-colors duration-150 ease-soft hover:border-ink/30" data-id="element-941" data-mp="39oiuabyx2ijg">
                <div className="flex items-start justify-between gap-4" data-id="element-942" data-mp="2vnokpq04ubj7">
                  <div className="min-w-0" data-id="element-943" data-mp="2vq1csvzlu29z">
                    <p className="text-[12px] text-clay" data-id="element-944" data-mp="2qwyeybnso6nz">{r.level === 'Compleet' ? 'Compleet protocol' : 'Startprotocol'}</p>
                    <h2 className="mt-1 font-display text-xl leading-snug text-ink" data-id="element-945" data-mp="236cgnc3le0r6">{r.name || 'Naamloos'}</h2>
                  </div>
                  <span className="shrink-0 text-right" data-id="element-946" data-mp="1y6q5d87bqul0">
                    <span className="block font-display text-xl text-ink" data-id="element-947" data-mp="dpqfumlk8vwp">{euro(totals.price)}</span>
                    {showMargin && costs && <span className="block text-[12px] text-muted" data-id="element-948" data-mp="4ptxt3toevam">
                        <MarginBadge percent={basketMarginPercent(marginLines(totals.items, costs.itemCosts, vatRateOf))} data-id="element-949" data-mp="4rohyfx4ijdn" /> marge
                      </span>}
                  </span>
                </div>
                <div className="mt-4 flex -space-x-2" aria-hidden="true" data-id="element-950" data-mp="wf6pq0j4y0ps">
                  {totals.items.map(p => <ProductImage key={p.id} src={p.image} title={p.name} className="h-10 w-10 shrink-0 rounded-full border-2 border-white p-1" data-id="element-951" data-mp="ngusvgroe6ow" />)}
                </div>
                <p className="mt-auto pt-4 text-[13px] text-muted" data-id="element-952" data-mp="386tyvkp5u5ov">
                  {plural(totals.items.length, 'product', 'producten')} · {monthsLabel(r.lasts)}
                  {gift ? ` · ${gift.title.toLowerCase()}` : ''}
                  {treatment ? ` · hoort bij ${treatment.name}` : ''}
                  {errors > 0 && <span className="text-clay" data-id="element-953" data-mp="3no20060yyxyx"> · controleer dit protocol</span>}
                </p>
              </Link>
            </li>;
      })}
      </ul>}
    </div>;
}